import React, { useEffect, useState } from "react";
import * as jnb from "react-bootstrap";
import { ErrorMessage, Field, Form, FormikProvider, useFormik } from "formik";

import axios from "axios";
import { Container, Table, Row, Col } from "react-bootstrap";

import Swal from "sweetalert2";

import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { config } from "../../../CommonUtils/CommonUrl/CommonUrls";
import CommonPost from "../../../CommonUtils/CommonAxios/CommonPost";
import { failureAlert } from "../../../CommonUtils/CommonPopupAndAlerts/SweetAlerts";
import Header from "../../../Header/Header";
import { CommonAxiosGet } from "../../../CommonUtils/CommonAxios/CommonAxios";



export default function AloDetailsUpdate() {
 
  let navigate = useNavigate();

  const lgdDisttcode = localStorage.getItem("lgd_dist_code");
  const [PendingMandals, setPendingMandals] = useState([]);

  function GetMndalsMappedData() {
   // https://swapi.dev.nidhi.apcfss.in/boc/alodtls/502
 
    // const URLL =config.url.BOC_URL + "districtwisedashboard/mandalpending/" + lgdDisttcode;
   const URLL = config.url.BOC_URL + "alodtls/" + lgdDisttcode;
    console.log("MandaL PEnding URLLL>", URLL);
    CommonAxiosGet(URLL).then((res) => {
        if(res.data.alodtls_status === true){
         setPendingMandals(res.data.alodtls);
        console.log("PENDINGMANDALS DATA", res.data.alodtls);
        }
      
    });
  }

  const [getpendingMandals, setpendingMandals] = useState([]);

  function GetPendingMandals() {
    const urlmandal = config.url.BOC_URL + "mandals/" + lgdDisttcode;
    CommonAxiosGet(urlmandal).then((res) => {
      console.log("API DATA mandals>>>>>>", res.data.mandals);

      if (res.data.status === true) {
        setpendingMandals(res.data);
        for (let i = 0; i < res.data?.mandals?.length; i++) {
          formIk.setFieldValue(
            `alos[${i}].mandal_id`,
            res.data?.mandals[i]?.mandal_code
          );
        }
      }
    });
  }

  let listOfObjects = [];
  let length = getpendingMandals?.mandals?.length;
  // console.log("length", length)
  for (let i = 0; i < length; i++) {
    if (
      getpendingMandals?.mandals !== undefined &&
      getpendingMandals?.status === true
    ) {
      listOfObjects.push({
        mandal_id: "",
        org_id: "",
      });
    } else {
    }
  }
  const formIk = useFormik({
    initialValues: {
      insert_by: "TestAloDetails",
      alos: listOfObjects,
    },
    validationSchema: Yup.object().shape({
      alos: Yup.array().of(
        Yup.object().shape({
          org_id: Yup.string().required("Required"),
        })
      ),
    }),

    onSubmit: (values) => {
      let alos = values.alos.filter((ar) => ar.org_id);
      console.log("filteresdata----------->", alos);

      Swal.fire({
        title: "Are you sure?",
        text: "Please check",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          // values.insert_by="test";
          values.alos = alos;
         // console.log("values>>>", values);
          CommonPost.AloUpdate(values).then((res) => {
            console.log("res>>>", res);
            if (res.data != null) {
              if (res.data.scode === "01") {
                //console.log("resssssss>>", res.data.ResponseCode);

                Swal.fire({
                  text: "Mapped Successfully",
                  icon: "success",
                }).then((refresh) => {});
                navigate("/AloDrillDown");
              } else {
                failureAlert(res.data.sdesc);
              }
            } else {
              failureAlert(res.data.sdesc);
            }
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire("Canceled", "Do corrections and then retry :)", "error");
        }
      });
    },
  });
 function backNav(){
  navigate("/AloDrillDown")
 }
  useEffect(() => {
    GetMndalsMappedData();
    GetPendingMandals();
    // GetMappedData();
  }, []);

  return (
    <>
      <Header />
      <div className="main_section"> </div>
      <FormikProvider value={formIk}>
        <Form onSubmit={formIk.handleSubmit} onChange={formIk.handleChange}>
          <Container>
            <Row>
              <Col
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                xxl={12}
                className="page-titlespacing d-flex justify-content-between"
              >
                <div className="inner-herbpage-service-title1">
                  <h1> ALO Details</h1>
                </div>
                <div className="text-right">
                  <button type="button" className="btn btn-success" onClick={backNav}>Back</button>
                </div>
              </Col>
            </Row>
          </Container>
          <Container className="outer-page-content-container">
            {/* <div className="jumbotron mt20 form-card-jnb" style={{ marginTop: "5px" }}> */}

            <Row className="px-4 pt-5">
              <div className="inner-herbpage-service-title-sub">
                <h3 className="text-success" style={{ color: "blue" }}>
                  {localStorage.getItem("distname")} &nbsp; District ALO Mandals UnMapped
                </h3>
              </div>
              <center>
                <Table
                  className="table table-condensed table-bordered table-striped table-responsive mt-3 mb-5"
                  style={{ alignItems: "center" }}>
                  <thead>
                    <tr>
                      <th>S.No</th>
                      {/* <th>District</th> */}
                      <th>UnMapped Mandals</th>
                      <th>ALO Office</th>
                    </tr>
                  </thead>
                  <tbody>
                    {getpendingMandals?.mandals &&
                      getpendingMandals?.mandals?.map((data, i) => {
                        return (
                          <tr>
                            <td>{i + 1}</td>
                            <td style={{textAlign:"center"}}>
                              <Field
                                type="hidden"
                                name={`alos[${i}].mandal_id`}
                                className="form-control w-100 nb-1"
                              />
                              {data.mandal_name}
                            </td>
                            <td style={{ width: '580px' }}>
                              <Field
                                as="select"
                                name={`alos[${i}].org_id`}
                                className="form-control form-control-md"
                                style={{ with: "20px" }}
                                required
                              >
                                <option value="">--Select--</option>
                                {PendingMandals !== undefined &&
                                  PendingMandals?.map((ms, i) => {
                                    return (
                                      <option key={i} value={ms.org_id}>
                                        {ms.org_name}
                                      </option>
                                    );
                                  })}
                              </Field>
                              <ErrorMessage
                                name={`alos[${i}].org_id`}
                                component="div"
                                className="text-danger"
                              />
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </Table>
              </center>
            </Row>
            <jnb.Row>
              <jnb.Col xs={12} sm={12} md={12} lg={11} xl={11} xxl={11}>
                <div className="d-flex flex-row justify-content-end px-3">
                  <jnb.Button type="submit" className="btn btn-success">
                    Submit
                  </jnb.Button>
                </div>
              </jnb.Col>
            </jnb.Row>
          </Container>
        </Form>
      </FormikProvider>
    </>
  );
}
